import {Component} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {UserService} from "../../common/user.service";
import {LoggerService} from "../../common/logger.service";

@Component({
    selector: 'global-message',
    templateUrl: './global-message.component.html',
    styleUrls: ['./global-message.component.scss'],
    standalone: false
})
export class GlobalMessageComponent extends BaseComponent {

    constructor(
        private userService: UserService,
        private loggerService: LoggerService,
    ) {
        super(userService, loggerService);
    }

    closeGlobalMessage(){
        this.showGlobalMessage = false;
    }
}
